module.exports = __webpack_public_path__ + "static/view-1e65e51dc81a3b3b319555bf53de3d1b.png";